import { keepPreviousData } from "@tanstack/react-query";

import { $api } from "@/shared/api";

import type { DashboardPeriod } from "../model/DASHBOARD_PERIODS";

// Дашборд команды за период (`GET /api/dashboard`, только staff). Бэкенд считает всё из базы и
// снимка Umami; при смене периода прошлые цифры видны, пока не придут новые.
// `enabled` — только для команды: остальным бэкенд ответит 403.
export const useTeamDashboard = (period: DashboardPeriod, enabled: boolean) =>
  $api.useQuery(
    "get",
    "/api/dashboard",
    { params: { query: { period } } },
    { placeholderData: keepPreviousData, enabled },
  );
